import {FormProvider, useForm} from 'react-hook-form';

import ButtonPanel from 'components/Button/Panel';
import FormCancel from 'components/form/Cancel';
import FormCombobox from 'components/form/Combobox';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


const categoryOptions = [
  {label: 'Language', value: 'LANGUAGE'},
  {label: 'Frontend', value: 'FRONTEND'},
  {label: 'Backend', value: 'BACKEND'},
  {label: 'Database', value: 'DATABASE'},
  {label: 'DevOps', value: 'DEVOPS'},
  {label: 'AI', value: 'AI'},
];

export default function TechStackForm({techStack, onSave, onClose}) {
  const appContext = useAppContext();
    
  const formMethods = useForm({
    defaultValues: {
      techStackName: techStack?.techStackName ?? '',
      category: techStack?.category ?? '',
    },
  });
  
  const {handleSubmit, setError} = formMethods;
  
  const onSubmit = async (values) => {
    const apiMethod = techStack?.techStackId ? appContext.api.put : appContext.api.post;
    const urlVal = 'api/v1/techStacks';
    const apiUrl = techStack?.techStackId ? `${urlVal}/update/${techStack.techStackId}` : urlVal + '/create';

    try {
      const rez = await apiMethod(apiUrl, {
        json: {
          techStackName: values?.techStackName,
          category: values?.category?.value,
        },
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormCombobox
          name="category"
          label="Category"
          isMulti={false}
          options={categoryOptions}
          required={true}
        />
        <FormText
          name="techStackName"
          label="Tech stack name"
          required={true}
        />
        <ButtonPanel
          buttons={[
            <FormSubmit key="save">Save</FormSubmit>,
            <FormCancel key="cancel" actionHandler={onClose}>Cancel</FormCancel>,
          ]}
        />
      </form>
    </FormProvider>
  );
}
